import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { SharedService } from 'src/app/services/shared.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-roles-d',
  templateUrl: './roles-d.component.html',
  styleUrls: ['./roles-d.component.css']
})
export class RolesDComponent {

  opE: any;
  rol = {
    nombre: ''
  }
  token: any;
  retrievedRol: any;

  // declaración de los mensajes de validación 
  showErrorMessageNombre : boolean = false;

  mensajeValidacionNombre : string = '';

  mensaje                 : string  = 'Campo requerido.';

  iconoMostrar: string = '';
  nameBoton: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private messagesService: MessagesService,
    private navigationService: NavigationService) { }

    ngOnInit() {


      this.token = String(localStorage.getItem('token1'))
      this.navigationService.disableNavigation();
      this.opE = this.route.snapshot.paramMap.get('datos');
      if (this.opE === '1') {//obtendgo creditor para actualizar
        this.retrievedRol = this.sharedService.getDataArray();
        this.cargarRol(this.retrievedRol);
      }

      this.obtnerIcono();
    }

    obtnerIcono(){

      this.iconoMostrar = this.opE === '1' ? 'bi-arrow-left-circle' : 'bi-x-circle';
      this.nameBoton = this.opE === '1' ? 'Regresar' : 'Cancelar';
    }

    async cargarRol(getrol: any){
      this.rol.nombre = getrol.Rls_Nombre
    }
  
    async validaFormulario(guardar: any, editar:any) {
      if (this.rol.nombre === '') {
        this.messagesService.showError('Todos los campos son obligatorios');
        return;
      }
      if(guardar === true){
        this.guardar()
      }
      if(editar === true){
        this.editar()
      }
    }
  
    editar(){
      this.requestsService.editRol(this.rol, this.retrievedRol.Id_Rol, this.token).subscribe(
        (res) => {
          this.confirmacion(res.message);
        },(err) => {
          this.mostrarError(err.error.error[0].message);
        }
      )
    }
  
    guardar(){
      this.requestsService.createRol(this.rol, this.token).subscribe(
        (res) => {
          this.confirmacion(res.message);
        },(err) => {
          this.mostrarError(err.error.error[0].message);
        }
      )
    }
  
    eliminar(){
      this.requestsService.deleteRol(this.retrievedRol.Id_Rol, this.token).subscribe(
        (res) => {
          this.confirmacion(res.message);
        },(err) => {
          this.mostrarError(err.error.error[0].message);
        }
      )
    }

    confirmacion(mensajeConfirmacion: string){
      this.messagesService.showMessage(mensajeConfirmacion);
      this.cancelar();
    }
  
    mostrarError(mensajeError: string){
      this.messagesService.showError(mensajeError);
    }
  
    cancelar() {
      this.router.navigate(['/roles']);
    }
  
    private isNumber(value: any): boolean {
      return !isNaN(parseFloat(value)) && isFinite(value);
    }
    
    private isValidEmail(email: string): boolean {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(email);
    }

    // mensajes de validación 
    mostrarMensaje(campo: any, tipo: string) {
      switch(tipo){
        case 'nombre':
          if (campo.invalid && (campo.dirty || campo.touched)) {
            this.showErrorMessageNombre = true;
            this.mensajeValidacionNombre = this.mensaje;
          } else {
            this.showErrorMessageNombre = false;
          }
        break;
      }
    }
}
